<template>
  <component
    :is="componentName"
    :ref="componentName"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template #cover="{ playEnd }">
      <slot name="cover" :play-end="playEnd" />
    </template>
  </component>
</template>

<script>
import LivePlayer from './LivePlayer/index.vue'
import AliPlayer from './Aliplayer/index.vue'

import { judgeClient } from '@/utils/util'

export default {
  name: 'Player',
  components: {
    LivePlayer,
    AliPlayer
  },
  computed: {
    componentName() {
      // 先判断是趣直播还是回放，再判断是安卓还是IOS
      // return this.$attrs.type === 'playback' ? 'LivePlayer' : judgeClient() === 'IOS' ? 'AliPlayer' : 'LivePlayer'
      return judgeClient() === 'IOS' ? 'AliPlayer' : 'LivePlayer'
    },
    video() {
      if (this.componentName === 'AliPlayer') {
        return this.$refs[this.componentName].player?.tag
      } else {
        return this.$refs[this.componentName].dp?.video
      }
    },
    player() {
      if (this.componentName === 'AliPlayer') {
        return this.$refs[this.componentName].player
      } else {
        return this.$refs[this.componentName].dp
      }
    }
  },
  methods: {
    isFullscreen() {
      if (this.componentName === 'AliPlayer') {
        return this.video.webkitPresentationMode === 'fullscreen'
      } else {
        return this.$refs[this.componentName].isfullscreen
      }
    }
  }
}
</script>
